import { WA_MSG, whatsappUrl } from '../lib/whatsapp.js';

export default function Hero() {
  return (
    <section className="relative isolate min-h-[100dvh] overflow-hidden grain">
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1585747860715-2ba37e788b70?auto=format&fit=crop&w=2400&q=80"
          alt=""
          className="h-full w-full origin-center object-cover animate-ken"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/75 via-ink/60 to-ink" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_20%,rgba(201,162,122,0.18),transparent_55%)]" />
      </div>

      <div className="mx-auto flex min-h-[100dvh] max-w-content flex-col justify-end px-6 pb-16 pt-28 lg:px-8 lg:pb-24">
        <p className="font-display text-5xl font-extrabold tracking-tight text-bone opacity-0 animate-rise sm:text-7xl lg:text-8xl">
          H<span className="text-copper">barber</span>
        </p>

        <h1 className="mt-6 max-w-2xl font-display text-2xl font-semibold leading-tight tracking-tight text-bone opacity-0 animate-rise-delay sm:text-4xl lg:text-[2.75rem]">
          A operação da barbearia, do primeiro contato ao caixa.
        </h1>

        <p className="mt-5 max-w-md text-base leading-relaxed text-mist opacity-0 animate-rise-delay-2 sm:text-lg">
          Agenda, clientes, WhatsApp, comissões e app do barbeiro — em um só sistema.
        </p>

        <div className="mt-10 flex flex-wrap items-center gap-4 opacity-0 animate-rise-delay-2">
          <a
            href={whatsappUrl(WA_MSG.general)}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center rounded-md bg-copper px-6 py-3 text-sm font-semibold text-ink transition-transform duration-200 hover:bg-copper-soft active:scale-[0.98]"
          >
            Falar no WhatsApp
          </a>
          <a
            href="#produto"
            className="inline-flex items-center text-sm font-medium text-bone/80 underline-offset-4 transition-colors hover:text-bone hover:underline"
          >
            Ver o produto
          </a>
        </div>
      </div>
    </section>
  );
}
